<template>
  <div data-v-d22ef464="" data-v-2ac6a5fc="" class="faq">
    <div data-v-d22ef464="" class="row">
      <div data-v-d22ef464="" class="title">
        <h4 data-v-d22ef464="">账号类问题</h4>
      </div>
      <ul data-v-d22ef464="" class="faqlist">
        <li data-v-d22ef464="" class="">
          <div data-v-d22ef464="" class="t">
            <h4 data-v-d22ef464="">如何注册？ <i data-v-d22ef464=""></i></h4>
          </div>
          <div data-v-d22ef464="" class="c" style="display: none">
            <p data-v-d22ef464="">开户方式有两种：</p>
            <p data-v-d22ef464="">1、请点击网站首页“<span data-v-d22ef464="">免费开户</span> ”按钮，按照界面所规定的填写内容进行自助开户。</p>
            <p data-v-d22ef464="">2、联系<span data-v-d22ef464="">在线客服</span>提供您的联系电话和取款银行卡姓名即可开出游戏账号 。</p>
            <!----><!---->
          </div>
        </li>
        <li data-v-d22ef464="" class="">
          <div data-v-d22ef464="" class="t">
            <h4 data-v-d22ef464="">忘记密码怎么办？ <i data-v-d22ef464=""></i></h4>
          </div>
          <div data-v-d22ef464="" class="c" style="display: none">
            <!---->
            <p data-v-d22ef464="">(1) 您可以自行找回密码：于登录页面的密码左下方点击[忘记账号、密码？]，选择[我忘记密码了]，依据提示自助找回密码即可</p>
            <p data-v-d22ef464="">(2) 您可以联系24小时<span data-v-d22ef464="">在线客服</span>人员，通过客服人员<span data-v-d22ef464="">免费电话</span>给您协助找回您的账号密码。</p>
            <!---->
          </div>
        </li>
        <li data-v-d22ef464="" class="">
          <div data-v-d22ef464="" class="t">
            <h4 data-v-d22ef464="">怎么充币？ <i data-v-d22ef464=""></i></h4>
          </div>
          <div data-v-d22ef464="" class="c" style="display: none">
            <!----><!---->
            <p data-v-d22ef464="">登录账号后进入充币页面，选择您要的充币方式并输入金额，根据页面提示进行扫码转币或者人民币买币，交易完成后充值金额将会自动存入您的网站账户中。更详细的操作可以到首页上的"数字币充提指南"查看哦。</p>
          </div>
        </li>
      </ul>
    </div>
    <div data-v-d22ef464="" class="row">
      <div data-v-d22ef464="" class="title">
        <h4 data-v-d22ef464="">游戏类问题</h4>
      </div>
      <ul data-v-d22ef464="" class="faqlist">
        <li data-v-d22ef464="" class="">
          <div data-v-d22ef464="" class="t">
            <h4 data-v-d22ef464="">游戏结束后如何提币？ <i data-v-d22ef464=""></i></h4>
          </div>
          <div data-v-d22ef464="" class="c" style="display: none"><p>登录账号后进入提币页面，输入提币金额（第一次提币须绑定钱包）后选择提币钱包，确认提币后约30分钟内转入您的钱包。更详细的操作可以到首页上的"数字币充提指南"查看哦。</p></div>
        </li>
        <li data-v-d22ef464="" class="">
          <div data-v-d22ef464="" class="t">
            <h4 data-v-d22ef464="">提币到账如何变现？ <i data-v-d22ef464=""></i></h4>
          </div>
          <div data-v-d22ef464="" class="c" style="display: none">
            <p>登录账号后进入提币页面，点选"卖币变现"进入后选择您要的交易所，输入卖币数量进行提交，使用您的钱包向交易所提供的转币地址进行转账，交易成功后变现的金额会自动转入您提供的指定账户中。更详细的操作可以到首页的"数字币充提指南"查看哦。</p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'about',
  data() {
    return {};
  },
  methods: {},
  mounted() {
    let that = this;
    $('.faqlist li').click(function () {
      $(this).toggleClass('active').find('.c').slideToggle(300);
    });
  },
};
</script>

<style lang="scss" scoped>
@import '../../../static/css/chunk-308fde2c.49ee2761.css';
</style>



// WEBPACK FOOTER //
// src/components/main/faq.vue